export function workbayIdToName(workbayId: number) {
  //진행상태  W:대기중, P:진행중, E:조기마감, C:마감
  switch (workbayId) {
    case 1:
      return '양초작업장';
    case 2:
      return '화장지작업장';
    case 3:
      return '핸드타올작업장';
    default:
      return '';
  }
}
